import { cloneDeep } from 'lodash'

const state = {
  showImage: false,
  currentImage: {
    url: '',
    alt: ''
  }
}

const getters = {
  getCurrentImage: state => state.currentImage,
  getShowImage: state => state.showImage
}

const mutations = {
  UPDATE_CURRENT_IMAGE: (state, object) => {
    state.currentImage = cloneDeep(object)
  },
  UPDATE_SHOW_IMAGE: (state, boolean) => {
    state.showImage = boolean
  }
}

const actions = {
  updateCurrentImage: ({ commit, dispatch }, image) => {
    commit('UPDATE_CURRENT_IMAGE', image)
    dispatch('updateShowImage', image.url !== '')
  },
  updateShowImage: ({ commit }, status) => {
    commit('UPDATE_SHOW_IMAGE', status)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
